const sha1 = require('sha1');
//
export default class Organization {
  constructor(API) {
    this.api = API;
  }
  /* CRUD */
  async createOrganization(orgObj) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/organization/new';
    req.body = { ...orgObj };
    return await req.exec();
  }
  async updateOrganization(orgObj, orgID) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = '/organization/' + orgID;
    req.body = { ...orgObj };
    return await req.exec();
  }
  async deleteOrganization(orgID, isSoft) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = '/organization/' + orgID + (isSoft ? '/soft' : '');
    return await req.exec();
  }
  async getOrganization(orgID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/organization/' + orgID;
    return await req.exec();
  }
  async getOrganizationByHashedWSID(worksafeID, forcePlain) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/organization/hashed/' + (forcePlain ? worksafeID : sha1(worksafeID));
    return await req.exec();
  }
  /* Search */
  async searchOrganizationsByTerm(searchTerm, filters) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/organizations/search';
    req.body = { searchTerm, filter: filters };
    return await req.exec();
  }
  async searchOrganizationsByIDs(filters) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/organizations/search/byIDs';
    req.body = { filter: filters };
    return await req.exec();
  }
  async searchOrganizationsAutocomplete(value) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/organizations/search/autocomplete';
    req.body = { value };
    return await req.exec();
  }
  async exportOrganizationsSearch(searchTerm, filters) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/organizations/search/export';
    req.body = { searchTerm, filter: filters };
    req.bodyType = 'JSON/BLOB';
    return await req.exec();
  }
  async getSearchOrganizationCitiesValues() {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/organizations/cities';
    return await req.exec();
  }
  async getOrganizationContacts(orgID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/organization/' + orgID + '/contacts/search';
    return await req.exec();
  }
  async getOrganizationLocations(orgID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/organization/' + orgID + '/locations';
    return await req.exec();
  }
  async exportOrganizationContacts(orgID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/organization/' + orgID + '/contacts/export';
    req.bodyType = 'JSON/BLOB';
    return await req.exec();
  }
}
